
import { createSlice } from "@reduxjs/toolkit";

const CART_STORAGE_KEY = "cartProduct";

const loadCartFromStorage = () => {
    const cart = localStorage.getItem(CART_STORAGE_KEY);
    return cart ? JSON.parse(cart) : [];
};

const saveCartToStorage = (cart) => {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
};

const CartItemData = JSON.parse(localStorage.getItem('cartProduct')) || [];

export const addToCartSlice = createSlice({
    name: "cart",
    initialState: {
        cart: loadCartFromStorage(),
        totalQuantity: 0,
        totalPrice: 0,
        cartCount: CartItemData?.length,
        cartModal : false,
    },
    reducers: {
        addToCart: (state, action) => {
            const testt = action.payload;
            state.cart = testt;
        },
        setCartCount: (state, action) => {
            state.cartCount = action.payload;
        },
        setCartModal: (state, action) => {
            state.cartModal = action.payload;
        },
        removeFromCart: (state, action) => {
            const planID = action.payload;
            state.cart = state.cart.filter(
                (item) => item.planID !== planID
            );
            saveCartToStorage(state.cart);
            
            const guestCartStr = localStorage.getItem('guestCartProduct');
            if (guestCartStr) {
                let guestCart = JSON.parse(guestCartStr);
                const originalLength = guestCart.length;
                guestCart = guestCart.filter((item) => item.planID !== planID);
                if (guestCart.length !== originalLength) {
                    if (guestCart.length > 0) {
                        localStorage.setItem('guestCartProduct', JSON.stringify(guestCart));
                    } else {
                        localStorage.removeItem('guestCartProduct');
                    }
                }
            }
        },
        getCartTotal: (state) => {
            let { totalQuantity, totalPrice } = state.cart.reduce(
                (cartTotal, cartItem) => {
                    const { sellingPrice, quantity } = cartItem;
                    const itemTotal = parseFloat(sellingPrice) * quantity;
                    const total = itemTotal.toFixed(2)
                    cartTotal.totalPrice += Number(total);
                    cartTotal.totalQuantity += parseInt(quantity);
                    return cartTotal;
                },
                {
                    totalPrice: 0,
                    totalQuantity: 0,
                }
            );

            // Ensure totalPrice has two decimal places
            state.totalPrice = totalPrice;
            state.totalQuantity = totalQuantity;
        },

        increaseItemQuantity: (state, action) => {
            state.cart = state.cart.map((item) => {
                if (item.planID === action.payload) {
                    return { ...item, quantity: item.quantity + 1 }; 
                  /*  return { ...item, quantity:  1 }; */
                }
                return item; 
            });
        },
        decreaseItemQuantity: (state, action) => {
            state.cart = state.cart.map((item) => {
                if (item.planID === action.payload) {
                    return { ...item, quantity: Math.max(item.quantity - 1, 0) }; 
                }
                return item;
            });
        },
        updateCartQuantity: (state, action) => {
            const { planID, quantity } = action.payload;
            const item = state.cart.find(x => x.planID === planID);

            if (item) {
                item.quantity = quantity;
            }

            // localStorage update
            localStorage.setItem("cartProduct", JSON.stringify(state.cart));
        },
        resetCart: (state) => {
            state.cart = [];
            localStorage.removeItem('guestCartProduct');
        },
    },
});

export const {
    addToCart,
    removeFromCart,
    setCartModal,
    setCartCount,
    increaseItemQuantity,
    decreaseItemQuantity,
    updateCartQuantity,
    getCartTotal,
    resetCart } = addToCartSlice.actions;

export default addToCartSlice.reducer;
